import { render } from "./opinionsPage.vue?vue&type=template&id=9b7f3e7a&scoped=true"
import script from "./opinionsPage.vue?vue&type=script&lang=js"
export * from "./opinionsPage.vue?vue&type=script&lang=js"

import "./opinionsPage.vue?vue&type=style&index=0&id=9b7f3e7a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b7f3e7a"]])

export default __exports__